module.exports = __webpack_public_path__ + "img/button-bg.f01f615c.png";